import { Component, Input } from '@angular/core';

@Component({
    selector: 'metric-state',
    template: ''
})
export class MetricStateComponent {

    @Input() label: string;
    @Input() predicate: string;
    @Input() value: any;
    @Input() valueRef: string;
    @Input() severity: string;
    @Input() stateBarColor: string;
}

export enum MetricStateSeverity {       // order is important
    NEUTRAL,
    SUCCESS,
    WARNING,
    CRITICAL
}